<script setup lang="ts">
  import type { Component } from "vue";
  import type { SidebarMenuButtonProps } from "./SidebarMenuButtonChild.vue";
  import { reactiveOmit } from "@vueuse/core";
  import { Tooltip } from "@/components/ui/tooltip";
  import SidebarMenuButtonChild from "./SidebarMenuButtonChild.vue";
  import { useSidebar } from "./utils";

  defineOptions({
    inheritAttrs: false,
  });

  const props = withDefaults(
    defineProps<
      SidebarMenuButtonProps & {
        tooltip?: string | Component;
      }
    >(),
    {
      as: "button",
      variant: "default",
      size: "default",
      tooltip: null,
    },
  );

  const { isMobile, state } = useSidebar();

  const delegatedProps = reactiveOmit(props, "tooltip");
</script>

<template>
  <SidebarMenuButtonChild
    v-if="!tooltip || state !== 'collapsed' || isMobile"
    v-bind="{ ...delegatedProps, ...$attrs }">
    <slot />
  </SidebarMenuButtonChild>

  <Tooltip
    v-else
    :content="typeof tooltip === 'string' ? tooltip : undefined"
    side="right">
    <template #default>
      <SidebarMenuButtonChild v-bind="{ ...delegatedProps, ...$attrs }">
        <slot />
      </SidebarMenuButtonChild>
    </template>
    <template
      v-if="typeof tooltip !== 'string'"
      #content>
      <component :is="tooltip" />
    </template>
  </Tooltip>
</template>
